
  import Vue from "vue";
  import Component from "vue-class-component";

  import EmployeeDetailsCardEmployments from "./EmployeeDetailsCardEmployments.vue";
  import EmployeeDetailsCardExport from "./EmployeeDetailsCardExport.vue";
  import EmployeeDetailsCardOperator from "./EmployeeDetailsCardOperator.vue";
  import EmployeeDetailsCardPersonal from "./EmployeeDetailsCardPersonal.vue";
  import EmployeeDetailsCardWages from "./EmployeeDetailsCardWages.vue";
  import FabButton from "@/components/FabButton.vue";
  import {Watch} from "vue-property-decorator";
  import EmployeeService from "@/service/EmployeeService";
  import {HeaderModule, HeaderMutations} from "@/store/modules/header";
  import {Mutation} from "vuex-class";
  import Employee from "@/model/Employee";
  import {MessageTypes} from "@/components/message-types";
  import {CompanyLocation} from "@/model/CompanyLocation";
  import eventBus from "@/eventbus";
  import EmployeeDetailsCardReactivationForm from "@/views/Employee/forms/EmployeeDetailsCardReactivationForm.vue";
  import EmployeeDetailsCardDeactivationForm from "@/views/Employee/forms/EmployeeDetailsCardDeactivationForm.vue";

  @Component({
    components: {
      EmployeeDetailsCardDeactivationForm,
      EmployeeDetailsCardReactivationForm,
      EmployeeDetailsCardEmployments,
      EmployeeDetailsCardExport,
      EmployeeDetailsCardOperator,
      EmployeeDetailsCardPersonal,
      EmployeeDetailsCardWages,
      FabButton
    }
  })
  export default class EmployeeDetails extends Vue {
    private employee: Employee = new Employee();
    private companyLocations: Array<CompanyLocation> | null = null;
    private speedDial = false;

    private snackbarTimeout = -1;

    @Mutation(HeaderMutations.SET_TITLE, {namespace: HeaderModule})
    private mutationTitle: any;

    get fullName() {
      if (this.employee.firstName && this.employee.lastName) {
        return this.employee.firstName + " " + this.employee.lastName;
      } else {
        return "";
      }
    }

    get employeeId(): number | null {
      const id = this.$route.params.employeeId;
      const isNum = /^\d+$/.test(id);
      if (isNum) {
        return Number(id);
      } else {
        return null;
      }
    }

    get isEditable(): boolean {
      return !this.isInactive && this.isAuthorized("Employee_EditOther_Edit");
    }

    get isInactive(): boolean {
      return this.employee && this.employee.active !== undefined && !this.employee.active;
    }

    get hasEmployments(): boolean {
      return this.employee.employments?.length > 0;
    }

    get hasWages(): boolean {
      return this.employee.wages?.length > 0;
    }

    @Watch("fullName")
    onFullNameChanged(value: string) {
      this.mutationTitle(value);
    }

    mounted() {
      this.load();
    }

    load() {
      if (this.employeeId) {
        EmployeeService.getEmployeeById(this.employeeId)
          .then(response => {
            this.employee = Object.assign(new Employee(), response.data);
          });
      }
    }

    update(updatedEmployee: Employee) {
      this.employee = Object.assign(new Employee(), updatedEmployee);
    }

    // used an object for state for readability
    handle_deactivated(state: {activationState: boolean}) {
      if(state.activationState) {
        this.employee.active = state.activationState;
      }
      this.load();
    }

    recreateWelcomePdf() {
      if (this.employeeId) {
        EmployeeService.createWelcomePdf(this.employeeId)
          .then(response => {
            if (response) {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              // @ts-ignore
              link.setAttribute("download", response.headers.filename);
              document.body.appendChild(link);
              link.click();
            }
          });
      }
    }

    showDeactivationForm() {
      if(this.employeeId && this.employee.active) {
        this.showForm(MessageTypes.OPEN_EMPLOYEE_DEACTIVATE);
      }
    }

    showReactivationForm() {
      if (this.employeeId && !this.employee.active) {
        this.showForm(MessageTypes.OPEN_EMPLOYEE_REACTIVATE);
      }
    }
    showForm(messageType:string) {
      const firstName = this.employee.firstName ?? "";
      const lastName = this.employee.lastName ?? "";
      eventBus.$emit(messageType, {employeeId: this.employeeId, uuid: this.employee.uuid, firstName, lastName});

    }
  }
